import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';

const { Box, Stack, Heading, Paragraph } = designSystem;

function StockGalleryEmptyState({ searchQuery = '' }) {
  const notFound = i18next.t('Sorry, but we haven\'t found anything for "{searchQuery}"', {
    searchQuery,
  });
  const notFoundDescription = i18next.t(
    'Please try a different search term or check on of the popular photos bellow'
  );

  return (
    <Box marginBottom="spacing-xs">
      <Stack gap="spacing-3-xs">
        <Heading type="heading-5">{notFound}</Heading>
        <Paragraph>{notFoundDescription}</Paragraph>
      </Stack>
    </Box>
  );
}

StockGalleryEmptyState.propTypes = {
  searchQuery: PropTypes.string,
};

export default StockGalleryEmptyState;
